const getOrientation = function () {
    const width = window.innerWidth || document.documentElement.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight;
    const orientation = height >= width ? 'Portrait' : 'Landscape';
    return orientation;
};

const capitalize = function (str = '') {
    return str.charAt(0).toUpperCase() + str.substr(1);
};

const getStartupDeviceString = () => {
    if (window.getStartupDeviceString) {
        return window.getStartupDeviceString();
    }
};

export const setAdobePageParams = () => {
    const adobePageParams = {};
    const oktaCookie = document.cookie.match(/oktaid=([^;]+)/);
    const adTargetProperty = window?.AppAdobeTrackingConfig?.adobeTargetProperty;

    if (oktaCookie) {
        adobePageParams['id.okta'] = oktaCookie[1];
    }

    if (adTargetProperty) {
        adobePageParams.at_property = adTargetProperty;
    }

    if (adTargetProperty) {
        window.targetPageParams = () => {
            return adobePageParams;
        };
    }
};

export const dealWithAdobeMc = () => {
    // override adobe identity with mcmid from query string param
    const adobeAnalytics = window?.AppAdobeTrackingConfig;
    const reportingSuiteId = adobeAnalytics?.suite?.mobile;
    if (adobeAnalytics && reportingSuiteId) {
        const s = window.s_gi(reportingSuiteId);
        const adobeId = window?.AppAdobeTrackingConfig?.adobeMc
            ?.split('|')
            .filter((param) => param.includes('MCMID'))?.[0]
            ?.split('=')?.[1];

        // override identity cookies
        if (adobeId) {
            s.marketingCloudVisitorID = adobeId;
            // s_ecid cookie override
            s.Util?.cookieWrite('s_ecid', `MCMID|${adobeId}`);
            // override AMVC - org cookie
            const identityCookieName = window.visitor?.cookieName;
            const oldCookie = s.Util?.cookieRead(identityCookieName);
            const newCookie = oldCookie.replaceAll(
                /MCMID\|[0-9]+\|/g,
                `MCMID|${adobeId}|`
            );
            s.Util?.cookieWrite(identityCookieName, newCookie);
        }
    }

    setAdobePageParams();
};

export const trackPageView = (props) => {
    try {
        const adobeAnalytics = window?.AppAdobeTrackingConfig;
        const reportingSuiteId = adobeAnalytics?.suite?.mobile;
        if (adobeAnalytics && reportingSuiteId) {
            const language = adobeAnalytics.locale;
            const { channel, pageName, shouldClearVars = true } = props;
            const startupDeviceString = capitalize(getStartupDeviceString());
            const orientation = getOrientation();
            const s = window.s_gi(reportingSuiteId);
            const lang = language === 'en' ? 'English' : 'Spanish';
            s.prop9 = lang;
            s.channel = channel;
            s.pageName = pageName;
            s.eVar73 = reportingSuiteId;
            s.prop5 = s.eVar34 = startupDeviceString;
            s.prop6 = s.eVar35 = orientation;
            s.prop7 = s.eVar36 = startupDeviceString + ': ' + orientation;
            s.prop22 = s.Util.cookieRead('oktaid')
                ? s.Util.cookieRead('oktaid')
                : null;
            s.prop39 = s.eVar39 =
                window.mlbOkta &&
                window.mlbOkta.getAuthClient().tokenManager.get('access_token')
                    ? 'Logged In'
                    : 'Not Logged In';
            s.prop71 = lang;

            window.setAppMeasurementConfig(s);

            // clear values for a page view
            const clearVars = function (s) {
                ['prop12', 'prop13', 'prop14', 'prop52', 'eVar48'].forEach(
                    (prop) => {
                        delete s[prop];
                    }
                );
            };

            Object.keys(props).forEach((prop) => (s[prop] = props[prop]));
            if (shouldClearVars) {
                clearVars(s);
            }
            s.t();
        }
    } catch (err) {
        console.log('trackPageView error', err);
    }
};

export const trackAsync = (props) => {
    // Hack to clear the props not being cleared in s.clearVars().
    const adobeAnalytics = window?.AppAdobeTrackingConfig;
    const reportingSuiteId = adobeAnalytics?.suite?.mobile;
    if (adobeAnalytics && reportingSuiteId) {
        const clearVars = function (s) {
            [
                'eVar13',
                'prop25',
                'eVar28',
                'prop26',
                'prop27',
                'prop28',
                'prop29',
                'prop30',
                'prop32',
                'prop33',
                'prop34',
                'prop43',
                'prop49',
                'eVar49',
                'prop54',
                'events'
            ].forEach((prop) => {
                delete s[prop];
            });
        };
        const { pageName, linkName = 'http://myGenericURL' } = props;
        const s = window.s_gi(reportingSuiteId);
        const startupDeviceString = capitalize(getStartupDeviceString());
        const orientation = getOrientation();

        s.clearVars();
        clearVars(s);

        s.pageName = pageName;
        s.eVar73 = reportingSuiteId;
        s.prop11 = 'Dynamic Page View';
        s.prop13 = props.prop13 ? props.prop13 : pageName;
        s.prop15 = startupDeviceString + ': ' + orientation;
        s.prop22 = s.Util.cookieRead('oktaid')
            ? s.Util.cookieRead('oktaid')
            : null;

        Object.keys(props).forEach(
            (prop) => (s[prop] = props[prop])
        );

        // async call
        s.tl(true, 'o', linkName);
    }
};

export default (f) => f;
